import React, { useState, useEffect, useRef } from "react";
import Pagination from "react-js-pagination";
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  TableContainer,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Input,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Checkbox,
  Select,
  Flex,
  Tooltip,
  Stack,
  FormLabel,
  Icon,
  Switch,
  FormControl,
  RadioGroup,
  Radio,
  VStack,
  IconButton,
} from "@chakra-ui/react";
import { LuChevronDown, LuSettings } from "react-icons/lu";
import { fetchWrapper } from "../../helpers";
import Papa from "papaparse";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "../../components/Header";
import PageLoader from '../../components/Loader/PageLoader';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';
import MAUForm from "./MauForm";
import UpdatePriceForm from "./UpdatePrice";
import BillingCharges from "./BillingCharges";
import OtherChannelsTab from "./OtherChannels";


function SaleList() {
  const inputRef = useRef(null);
  const [selectedCurrencyId, setSelectedCurrencyId] = useState("");
  const [currencyId, setCurrencyId] = useState("");
  const [currency, setCurrency] = useState({});

  const [list, setList] = useState([]);
  const [internationallist, setInternationalList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [InternationlistCount, setInternationalListCount] = useState(0);
  const [listCount, setListCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeType, setActiveType] = useState("sms"); // Default to "sms"
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [operator, setOperator] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [Moudata, setMoudata] = useState({});
  const [selectedOperator, setSelectedOperator] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [searchOperator, setSearchOperator] = useState("");
  const { id } = useParams();
  const [type, setType] = useState("");
  const [channels, setChannels] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [selectedChannelMarketing, setSelectedChannelMarketing] = useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [newPriceMarketing, setNewPriceMarketing] = useState('');
  const [modalType, setModalType] = useState('price');
  const [currencyList, setCurrencyList] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [priceConfiguration, setpriceConfiguration] = useState({});


  // Fix Charges Configuration state
  const [isFixChargesModalOpen, setIsFixChargesModalOpen] = useState(false);
  const [fixChargesConfig, setFixChargesConfig] = useState({
    enabled: false,
    amount: null,
    currency_id: '',
    charging_method: '', // 'fixed_monthly' or 'minimum_billing'
  });



  // Fix Charges Configuration modal handlers
  const handleOpenFixChargesModal = () => {
    // Load existing configuration if available
    // loadFixChargesConfig();
    setIsFixChargesModalOpen(true);
  };
  const handleOpenModal = (channelId, channelData, modalType) => {

    setSelectedChannel({ id: channelId, ...channelData });

    setSelectedChannelMarketing({ id: channelId, ...channelData });

    if (modalType === 'api_charges') {
      setModalType('channels');
      // Initialize selected channels from existing data or empty array
      const existingChannels = channelData?.channel_in_use?.filter((ch) => ch.allow === true).map(ch => ch.channel_id) || [];
      const existingChannelsMarketing = channelData?.channel_in_use_marketing?.filter((ch) => ch.allow === true).map(ch => ch.channel_id) || [];


      setSelectedChannel(existingChannels);
      setSelectedChannelMarketing(existingChannelsMarketing);
    } else {
      setModalType('price');
      setNewPrice(channelData.price ? channelData.price.toString() : 0);
      setNewPriceMarketing(channelData.marketing ? channelData.marketing.toString() : 0);

      setSelectedCurrencyId(channelData.currency_id ? channelData.currency_id.toString() : '');
    }

    setIsModalOpen(true);
  };




  const handleSavePrice = async () => {
    if (selectedChannel) {
      try {
        let updatedChannels = { ...channels };

        if (modalType === 'channels') {
          // Update only the channel_in_use within api_charges
          updatedChannels = {
            ...channels,
            api_charges: {
              ...channels.api_charges,
              channel_in_use: channelOptions.map(channel => ({
                channel_id: channel.id,
                allow: selectedChannel.includes(channel.id)
              })),
              channel_in_use_marketing: channelOptions.map(channel => ({
                channel_id: channel.id,
                allow: selectedChannelMarketing.includes(channel.id)
              })),
              update_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            }
          };
        } else {
          // For price updates
          updatedChannels = {
            ...channels,
            [selectedChannel.id]: {
              ...channels[selectedChannel.id],
              price: parseFloat(newPrice),
              marketing: parseFloat(newPriceMarketing),
              update_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
              currency_id: selectedCurrencyId,
            }
          };
        }

        const url = `${process.env.REACT_APP_API_URL}/sale_channel/update`;
        const updatedData = {
          id: +id,
          other_channel_sale: JSON.stringify(updatedChannels)
        };


        await fetchWrapper.post(url, updatedData);
        await OtherChannelsList(); // Refresh the data

        toast.success("Updated successfully");
        setIsModalOpen(false);
        setSelectedChannel(null);
        setNewPrice('');
        setNewPriceMarketing('');
        setSelectedChannel([]);
      } catch (error) {
        console.error("Error updating:", error);
        toast.error("Failed to update");
      }
    }
  };


  useEffect(() => {
    if (activeType === "other_channels") {
      OtherChannelsList()
      ChannelsList()

    } else {
      CountryList();
      OperatorList();
      loadExistingCountryCurrency()
      loadList(activeType, selectedCountry.id, selectedOperator.id);
      loadListForInternational(activeType, selectedCountry.id, selectedOperator.id);
      loadFixedCharges()
    }

  }, [activePage, selectedCountry, selectedOperator, activeType]);

  const loadList = async (type = "sms", countryId = "", operatorId = "") => {
    setLoading(true); // Show the loading spinner

    try {
      const url = type === "sms" || type === "ivr" || type === "sms_secondary" ? `${process.env.REACT_APP_API_URL}/sale/list-local?sale_channel_id=${id}&page=${activePage}&country_id=${countryId}&operator_id=${operatorId}&type=${type}` : `${process.env.REACT_APP_API_URL}/sale/list?sale_channel_id=${id}&page=${activePage}&country_id=${countryId}&operator_id=${operatorId}&type=${type}`;
      const data = await fetchWrapper.get(url);

      // Update the list and pagination state
      if (data?.rows) {
        setList(data?.rows || []);
        setListCount(data?.count || 0);
      } else {
        setMoudata(data)
      }

    } catch (error) {
      console.error("Error fetching data:", error.message);
    }

    setLoading(false); // Hide the loading spinner
  };
  const loadListForInternational = async (type = "sms", countryId = "", operatorId = "") => {
    setLoading(true); // Show the loading spinner

    try {
      const url = `${process.env.REACT_APP_API_URL}/sale/list?sale_channel_id=${id}&page=${activePage}&country_id=${countryId}&operator_id=${operatorId}&type=${type}`;
      const data = await fetchWrapper.get(url);

      // Update the list and pagination state
      if (data?.rows) {
        setInternationalList(data?.rows || []);
        setInternationalListCount(data?.count || 0);
      }

    } catch (error) {
      console.error("Error fetching data:", error.message);
    }

    setLoading(false); // Hide the loading spinner
  };
  const loadFixedCharges = async () => {
    setLoading(true); // Show the loading spinner

    try {
      const url = `${process.env.REACT_APP_API_URL}/sale/fixed-charges?sale_channel_id=${id}`;
      const data = await fetchWrapper.get(url);

      // Update the list and pagination state
      if (data?.data?.fixed_charges) {
        let filteredObj = data?.data?.fixed_charges?.filter((item => {
          if (item?.channel_id == activeTab) {
            return item
          }
        }))
        let filterdPrice = filteredObj?.length > 0 ? filteredObj[0] : {}

        setpriceConfiguration(filterdPrice)
        let object = {
          enabled: false,
          amount: filterdPrice?.amount,
          currency_id: filterdPrice?.channel_id,
          charging_method: filterdPrice?.type === "FMF" ? "fixed_monthly" : "minimum_billing", // 'fixed_monthly' or 'minimum_billing'
        }
        setFixChargesConfig(object)

      }

    } catch (error) {
      console.error("Error fetching data:", error.message);
    }

    setLoading(false); // Hide the loading spinner
  };
  const loadExistingCountryCurrency = async () => {
    setLoading(true); // Show the loading spinner

    try {
      const url = `${process.env.REACT_APP_API_URL}/sale/currency?channel_id=${activeTab}&id=${id}`;
      const data = await fetchWrapper.get(url);


      setCurrencyId(data?.currency_id);
      setCurrency(data?.data);

    } catch (error) {
      setCurrencyId("");
      console.error("Error fetching data:", error.message);
    }

    setLoading(false); // Hide the loading spinner
  };


  // Handle Tab Change
  const handleTabChange = (type) => {
    setActiveType(type); // Update the active type (sms or whatsapp)
    if (type !== "other_channels") {

      loadList(type, selectedCountry.id, selectedOperator.id); // Fetch the data for the selected type
    }
  };

  const ChannelsList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/channel/list`;
      const data = await fetchWrapper.get(url);
      let transformedData = data.data.map((item) => ({
        label: item?.name,
        value: item?.name,
        ...item
      }));
      setChannelOptions([...transformedData]);
    } catch (error) {
      console.error('Error fetching channels:', error);
    }
  };




  const CountryList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/country/list`;
    const data = await fetchWrapper.get(url);
    setCountry(data.rows);
  };
  const OtherChannelsList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/other-channel-sale?id=${id}`;
    const data = await fetchWrapper.get(url);
    // setCountry(data.rows);
    let channelList = data?.other_channel_sale === "" || data.other_channel_sale === null ? {
      "in_app": { "price": null, "update_at": null, "name": "In App", "id": "in_app", "currency_id": null },
      "push_notification": { "price": null, "update_at": null, "name": "Push Notification", "id": "push_notification", "currency_id": null },
      "email": { "price": null, "update_at": null, "name": "Email", "id": "email", "currency_id": null },
      "api_charges": { "price": null, "update_at": null, "channel_in_use": null, "name": "API Charges", "id": "api_charges", "currency_id": null }
      // "api_charges":{"price":20,"update_at":"2025-01-21 17:19","channel_in_use":[{channel_id:1,allow:true},{channel_id:2,allow:false},{channel_id:2,allow:true}]}
    } : JSON.parse(data?.other_channel_sale)
    setChannels(channelList);

  };

  const loadCurrency = async () => {
    const url = `${process.env.REACT_APP_API_URL}/currency/list`;
    const currencyData = await fetchWrapper.get(url);
    setCurrencyList(currencyData?.data);
  };
  useEffect(() => {
    loadCurrency();
  }, []);

  const OperatorList = async () => {
    const url = `${process.env.REACT_APP_API_URL}/operator/list`;
    const data = await fetchWrapper.get(url);
    setOperator(data.rows);
  };

  

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("sale_channel_id", id);

    const token = localStorage.getItem("user"); // adjust key if needed
    const url = `${process.env.REACT_APP_API_URL}/sale-csv`;

    axios
      .post(url, formData, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        loadList(activeType);
        loadListForInternational();
      })
      .catch((error) => {
        toast.error(`Failed to upload file: ${error.message}`);
      });

    if (inputRef.current) {
      inputRef.current.value = null;
    }
  }
};

  const handleClick = (type) => {
    setType(type);
    inputRef.current.click();
  };

  const onChangePaginate = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleSelect = (type, rs) => {
    const { id, name } = rs;
    if (type === "country") {
      setSelectedCountry({ id, name });
    } else if (type === "operator") {
      setSelectedOperator({ id, name });
    }
  };

  const meSearch = (type, e) => {
    if (type === "country") {
      setSearchCountry(e.target.value);
    }
    if (type === "operator") {
      setSearchOperator(e.target.value);
    }
  };

  const filteredCountries = country?.filter((rs) =>
    rs.name.toLowerCase().includes(searchCountry.toLowerCase())
  );

  const filteredOperator = operator?.filter((rs) =>
    rs.name.toLowerCase().includes(searchOperator.toLowerCase())
  );

  const meCsv = async () => {
    const fetch = `${process.env.REACT_APP_API_URL}/price/list`;
    const data = await fetchWrapper.get(fetch);
    const listed = data.rows;

    if (listed.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const csvData = listed.map((rs) => ({
      Country: rs?.Operator?.Country?.name || "",
      Operator: rs?.Operator?.name || "",
      MCC: rs?.Operator?.mcc || "",
      MNC: rs?.Operator?.mnc || "",
      Prefix: rs?.Operator?.prefix || "",
      "Sender ID": rs?.Operator?.sender_id === 0 ? "Default" : rs?.Operator?.sender_id,
      "SMS Cost": rs.sms_cost || "",
      "WhatsApp Cost": rs.whatsapp_cost || "",
    }));

    const csv = Papa.unparse(csvData);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute("download", "price_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("File downloaded successfully");
  };


  const onModalClose = () => {
    setIsModalOpen(false);
  }

  // Add this function to handle checkbox changes
  // Update handleCheckboxChange function
  const handleCheckboxChange = (channelId) => {
    setSelectedChannel(prev => {
      if (prev.includes(channelId)) {
        return prev.filter(id => id !== channelId);
      } else {
        return [...prev, channelId];
      }
    });
  };

  // Add this function to handle checkbox changes
  // Update handleCheckboxChange function
  const handleCheckboxChangeMarketing = (channelId) => {
    setSelectedChannelMarketing(prev => {
      if (prev.includes(channelId)) {
        return prev.filter(id => id !== channelId);
      } else {
        return [...prev, channelId];
      }
    });
  };


  const handleSaveFixCharges = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/sale/fixed-charges`;

      // Map charging_method to API type
      const typeMap = {
        fixed_monthly: "FMF",
        minimum_billing: "MBT",
      };

      const payload = {
        sale_channel_id: +id, // you need to pass this from props/state
        fixed_charges: {
          channel_id: +activeTab, // set this in your state when opening modal
          currency_id: +fixChargesConfig.currency_id,
          amount: fixChargesConfig.amount,
          type: typeMap[fixChargesConfig.charging_method] || "FMF",
        },
      };

      const response = await fetchWrapper.post(url, payload);

      if (response.success) {
        toast.success(response.message)
      }


      // Close modal and maybe refresh data
      setIsFixChargesModalOpen(false);
    } catch (error) {
      console.error("Error saving fixed charges:", error);
    }
  };



  return (
    <>
      <Header />
      <PageLoader isLoading={loading} />
      <input
        type="file"
        onChange={handleFileChange}
        accept=".csv"
        ref={inputRef}
        style={{ display: "none" }}
      />
      <BoxWrapper>
          <Tabs
            className="customer_tabs_section tabs_fit_content"
            onChange={(index) => {
              const typesMap = {
                sms: 1,
                sms_secondary: 7,
                whatsapp: 2,
                ivr: 4,
                other_channels: 5,
                mau: 5,
              };

              const typesOrder = ["sms", "sms_secondary", "whatsapp", "ivr", "other_channels", "mau"];
              const selectedType = typesOrder[index];
              const activeTypeValue = typesMap[selectedType];

              setActiveTab(activeTypeValue);
              setActiveType(selectedType);
              handleTabChange(selectedType);
            }}
          >
            <TabList className="customer_tabs_head_section">
              <Tab>SMS Cost</Tab>
              <Tab>SMS Secondary Cost</Tab>
              <Tab>WhatsApp Cost</Tab>
              <Tab>Voice (IVR)</Tab>
              <Tab>Other Channels</Tab>
              <Tab>MAU Slabs</Tab>
              <Tab>Billing Charges</Tab>
            </TabList>

            <TabPanels>

              <TabPanel className="customer_transaction_panel">
                {/* Table and filters for SMS Cost */}
                <HStack justifyContent="space-between" mb="25px">
                  <Box>
                    <Text fontSize="32px" fontWeight="300" color="#000000">
                      SMS Sales Price
                    </Text>
                  </Box>
                  <Box>
                    <HStack>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedCountry.name || "Country"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search country"
                                value={searchCountry}
                                onChange={(e) => meSearch("country", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("country", "")}>
                              All Show
                            </MenuItem>
                            {filteredCountries?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("country", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedOperator.name || "Operator"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search operator"
                                value={searchOperator}
                                onChange={(e) => meSearch("operator", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("operator", "")}>
                              All Show
                            </MenuItem>
                            {filteredOperator?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("operator", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Button className="filter-button" onClick={() => meCsv()}>
                          Download Price List
                        </Button>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("sms")}>
                            Import Updated Price List
                          </MenuButton>
                        </Menu>
                      </Box>
                    </HStack>
                  </Box>
                </HStack>

                <div  >
                  {/* <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.local_currency_id} text="Local SMS" type="local" /> */}
                  <HStack justifyContent="space-between" alignItems="center" mb="20px" >
                    <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.local_currency_id} text="Local SMS" type="local" />

                  </HStack>
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    overflow="hidden">
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th >Country</Th>
                          <Th >Operator</Th>
                          <Th >MCC</Th>
                          <Th >MNC</Th>
                          <Th >Prefix</Th>
                          <Th >Sender ID</Th>
                          <Th >Transaction & OTP Price </Th>
                          <Th >Marketing Message Price </Th>
                          <Th >Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody color={"black"}>
                        {list.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Operator?.Country?.name}</Td>
                            <Td>{rs?.Operator?.name}</Td>
                            <Td>{rs?.Operator?.mcc}</Td>
                            <Td>{rs?.Operator?.mnc}</Td>
                            <Td>{rs?.Operator?.prefix}</Td>
                            <Td>
                              {rs?.Operator?.sender_id === 0
                                ? "Default"
                                : rs?.Operator?.sender_id}
                            </Td>
                            <Td>{rs.sms_cost}</Td>
                            <Td>{rs.marketing_price}</Td>
                            <Td>27/08/2024</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    {/* <Flex justifyContent="center" alignItems="center" >
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={100}
                      totalItemsCount={listCount}
                      pageRangeDisplayed={100}
                      onChange={onChangePaginate}
                      innerClass="pagination"
                      itemClass="page-item"
                      activeLinkClass="page-link active"
                      linkClass="page-link"
                      prevPageText="Previous"
                      nextPageText="Next"
                    />
                  </Flex> */}
                  </TableContainer>
                </div>
                <div >
                  <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.int_currency_id} text="International SMS" type="int" />
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    >
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th>Country</Th>
                          <Th>Operator</Th>
                          <Th>MCC</Th>
                          <Th>MNC</Th>
                          <Th>Prefix</Th>
                          <Th>Sender ID</Th>
                          <Th>Transaction & OTP Price </Th>
                          <Th>Marketing Message Price </Th>
                          <Th>Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody fontSize="14px">
                        {internationallist?.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Operator?.Country?.name}</Td>
                            <Td>{rs?.Operator?.name}</Td>
                            <Td>{rs?.Operator?.mcc}</Td>
                            <Td>{rs?.Operator?.mnc}</Td>
                            <Td>{rs?.Operator?.prefix}</Td>
                            <Td>
                              {rs?.Operator?.sender_id === 0
                                ? "Default"
                                : rs?.Operator?.sender_id}
                            </Td>
                            <Td>{rs.sms_cost}</Td>
                            <Td>{rs.marketing_price}</Td>
                            <Td>27/08/2024</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Flex justifyContent="center" alignItems="center" >
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={50}
                        totalItemsCount={InternationlistCount}
                        pageRangeDisplayed={5}
                        onChange={onChangePaginate}
                        innerClass="pagination"
                        itemClass="page-item"
                        activeLinkClass="page-link active"
                        linkClass="page-link"
                        prevPageText="Previous"
                        nextPageText="Next"
                      />
                    </Flex>
                  </TableContainer>
                </div>
              </TabPanel>
              <TabPanel className="customer_transaction_panel">
                {/* Table and filters for SMS Cost */}
                <HStack justifyContent="space-between" mb="25px">
                  <Box>
                    <Text fontSize="32px" fontWeight="300" color="#000000">
                      SMS Secondary Sales Price
                    </Text>
                  </Box>
                  <Box>
                    <HStack>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedCountry.name || "Country"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search country"
                                value={searchCountry}
                                onChange={(e) => meSearch("country", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("country", "")}>
                              All Show
                            </MenuItem>
                            {filteredCountries?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("country", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedOperator.name || "Operator"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search operator"
                                value={searchOperator}
                                onChange={(e) => meSearch("operator", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("operator", "")}>
                              All Show
                            </MenuItem>
                            {filteredOperator?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("operator", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Button className="filter-button" onClick={() => meCsv()}>
                          Download Price List
                        </Button>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("sms_secondary")}>
                            Import Updated Price List
                          </MenuButton>
                        </Menu>
                      </Box>
                    </HStack>
                  </Box>
                </HStack>

                <div >
                  <HStack justifyContent="space-between" alignItems="center" mb="20px" >
                    <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.local_currency_id} text="Local SMS" type="local" />
                    
                  </HStack>
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    overflow="hidden">
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th>Country</Th>
                          <Th>Operator</Th>
                          <Th>MCC</Th>
                          <Th>MNC</Th>
                          <Th>Prefix</Th>
                          <Th>Sender ID</Th>
                          <Th>Transaction & OTP Price </Th>
                          <Th>Marketing Message Price </Th>
                          <Th>Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody fontSize="14px">
                        {list.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Operator?.Country?.name}</Td>
                            <Td>{rs?.Operator?.name}</Td>
                            <Td>{rs?.Operator?.mcc}</Td>
                            <Td>{rs?.Operator?.mnc}</Td>
                            <Td>{rs?.Operator?.prefix}</Td>
                            <Td>
                              {rs?.Operator?.sender_id === 0
                                ? "Default"
                                : rs?.Operator?.sender_id}
                            </Td>
                            <Td>{rs.sms_cost}</Td>
                            <Td>{rs.marketing_price}</Td>
                            <Td>27/08/2024</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    {/* <Flex justifyContent="center" alignItems="center" >
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={100}
                      totalItemsCount={listCount}
                      pageRangeDisplayed={100}
                      onChange={onChangePaginate}
                      innerClass="pagination"
                      itemClass="page-item"
                      activeLinkClass="page-link active"
                      linkClass="page-link"
                      prevPageText="Previous"
                      nextPageText="Next"
                    />
                  </Flex> */}
                  </TableContainer>
                </div>
                <div >
                  <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.int_currency_id} text="International SMS" type="int" />
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    overflow="hidden">
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th>Country</Th>
                          <Th>Operator</Th>
                          <Th>MCC</Th>
                          <Th>MNC</Th>
                          <Th>Prefix</Th>
                          <Th>Sender ID</Th>
                          <Th>Transaction & OTP Price </Th>
                          <Th>Marketing Message Price </Th>
                          <Th>Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody fontSize="14px">
                        {internationallist?.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Operator?.Country?.name}</Td>
                            <Td>{rs?.Operator?.name}</Td>
                            <Td>{rs?.Operator?.mcc}</Td>
                            <Td>{rs?.Operator?.mnc}</Td>
                            <Td>{rs?.Operator?.prefix}</Td>
                            <Td>
                              {rs?.Operator?.sender_id === 0
                                ? "Default"
                                : rs?.Operator?.sender_id}
                            </Td>
                            <Td>{rs.sms_cost}</Td>
                            <Td>{rs.marketing_price}</Td>
                            <Td>27/08/2024</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Flex justifyContent="center" alignItems="center" >
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={50}
                        totalItemsCount={InternationlistCount}
                        pageRangeDisplayed={5}
                        onChange={onChangePaginate}
                        innerClass="pagination"
                        itemClass="page-item"
                        activeLinkClass="page-link active"
                        linkClass="page-link"
                        prevPageText="Previous"
                        nextPageText="Next"
                      />
                    </Flex>
                  </TableContainer>
                </div>
              </TabPanel>

              {/* Add other tab panels for WhatsApp Cost, IVR, etc., here */}
              <TabPanel className="customer_transaction_panel">
                {/* Table and filters for WhatsApp Cost */}
                <HStack justifyContent="space-between" mb="25px">
                  <Box>
                    <Text fontSize="32px" fontWeight="300" color="#000000">
                      WhatsApp Sales Price
                    </Text>
                  </Box>
                  <Box>
                    <HStack>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedCountry.name || "Country"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search country"
                                value={searchCountry}
                                onChange={(e) => meSearch("country", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("country", "")}>
                              All Show
                            </MenuItem>
                            {filteredCountries?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("country", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Button className="filter-button" onClick={() => meCsv()}>
                          Download Price List
                        </Button>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("whatsapp")}>
                            Import Updated Price List
                          </MenuButton>
                        </Menu>
                      </Box>
                    </HStack>
                  </Box>
                </HStack>

                <div >
                  <HStack justifyContent="space-between" alignItems="center" mb="20px" >
                    <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.currency_id} />
                    
                  </HStack>
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    overflow="hidden">
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th>Country</Th>
                          <Th>OTP Cost</Th>
                          <Th>OTP Int Cost</Th>
                          <Th>Marketing</Th>
                          <Th>Utility Cost</Th>

                          <Th>Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody fontSize="14px">
                        {list.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Country?.name}</Td>
                            <Td>{rs?.otp_cost?.toFixed(4)}</Td>
                            <Td>{rs?.otp_int_cost?.toFixed(4)}</Td>
                            <Td>{rs?.marketing_cost?.toFixed(4)}</Td>
                            <Td>{rs?.utility_cost?.toFixed(4)}</Td>

                            <Td>{new Date(rs?.updated_at).toLocaleDateString()}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Flex justifyContent="center" alignItems="center" >
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={50}
                        totalItemsCount={listCount}
                        pageRangeDisplayed={5}
                        onChange={onChangePaginate}
                        innerClass="pagination"
                        itemClass="page-item"
                        activeLinkClass="page-link active"
                        linkClass="page-link"
                        prevPageText="Previous"
                        nextPageText="Next"
                      />
                    </Flex>
                  </TableContainer>
                </div>
              </TabPanel>
              <TabPanel className="customer_transaction_panel">
                {/* Table and filters for SMS Cost */}
                <HStack justifyContent="space-between" mb="25px">
                  <Box>
                    <Text fontSize="32px" fontWeight="300" color="#000000">
                      Voice (IVR) Sales Price
                    </Text>
                  </Box>
                  <Box>
                    <HStack>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedCountry.name || "Country"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search country"
                                value={searchCountry}
                                onChange={(e) => meSearch("country", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("country", "")}>
                              All Show
                            </MenuItem>
                            {filteredCountries?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("country", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton
                            as={Button}
                            rightIcon={<LuChevronDown />}
                            className="menu-filter"
                          >
                            {selectedOperator.name || "Operator"}
                          </MenuButton>
                          <MenuList>
                            <Box p="10px">
                              <Input
                                placeholder="Search operator"
                                value={searchOperator}
                                onChange={(e) => meSearch("operator", e)}
                              />
                            </Box>
                            <MenuItem onClick={() => handleSelect("operator", "")}>
                              All Show
                            </MenuItem>
                            {filteredOperator?.slice(0, 10).map((rs, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => handleSelect("operator", rs)}
                              >
                                {rs.name}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </Menu>
                      </Box>
                      <Box>
                        <Button className="filter-button" onClick={() => meCsv()}>
                          Download Price List
                        </Button>
                      </Box>
                      <Box>
                        <Menu>
                          <MenuButton as={Button} className="menu-filter-button" onClick={() => handleClick("ivr")}>
                            Import Updated Price List
                          </MenuButton>
                        </Menu>
                      </Box>
                    </HStack>
                  </Box>
                </HStack>

                <div >
                  <HStack justifyContent="space-between" alignItems="center" mb="20px" >
                    <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.local_currency_id} text="Local SMS" type="local" />

                   
                  </HStack>
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    overflow="hidden">
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th>Country</Th>
                          <Th>Operator</Th>
                          <Th>MCC</Th>
                          <Th>MNC</Th>
                          <Th>Prefix</Th>
                          <Th>Sender ID</Th>
                          <Th>Voice Cost</Th>

                          <Th>Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody fontSize="14px">
                        {list.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Operator?.Country?.name}</Td>
                            <Td>{rs?.Operator?.name}</Td>
                            <Td>{rs?.Operator?.mcc}</Td>
                            <Td>{rs?.Operator?.mnc}</Td>
                            <Td>{rs?.Operator?.prefix}</Td>
                            <Td>
                              {rs?.Operator?.sender_id === 0
                                ? "Default"
                                : rs?.Operator?.sender_id}
                            </Td>
                            <Td>{rs.sms_cost}</Td>

                            <Td>27/08/2024</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    
                  </TableContainer>
                </div>
                <div >
                  <UpdatePriceForm data={currencyList} activeTab={activeTab} id={id} currencyId={currency?.int_currency_id} text="International SMS" type="int" />
                  <TableContainer width="100%"
                    bg="white"
                    borderRadius="lg"
                    border="1px solid"
                    borderColor="gray.200"
                    overflow="hidden">
                    <Table
                      variant="simple" width="100%"
                      mb={10}
                    >
                      <Thead bg="#f7f7f7">
                        <Tr>
                          <Th>Country</Th>
                          <Th>Operator</Th>
                          <Th>MCC</Th>
                          <Th>MNC</Th>
                          <Th>Prefix</Th>
                          <Th>Sender ID</Th>
                          <Th>SMS Cost</Th>
                          <Th>Last Updated</Th>
                        </Tr>
                      </Thead>

                      <Tbody fontSize="14px">
                        {internationallist.map((rs, index) => (
                          <Tr key={index}>
                            <Td>{rs?.Operator?.Country?.name}</Td>
                            <Td>{rs?.Operator?.name}</Td>
                            <Td>{rs?.Operator?.mcc}</Td>
                            <Td>{rs?.Operator?.mnc}</Td>
                            <Td>{rs?.Operator?.prefix}</Td>
                            <Td>
                              {rs?.Operator?.sender_id === 0
                                ? "Default"
                                : rs?.Operator?.sender_id}
                            </Td>
                            <Td>{rs.sms_cost}</Td>
                            <Td>27/08/2024</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Flex justifyContent="center" alignItems="center" >
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={50}
                        totalItemsCount={InternationlistCount}
                        pageRangeDisplayed={5}
                        onChange={onChangePaginate}
                        innerClass="pagination"
                        itemClass="page-item"
                        activeLinkClass="page-link active"
                        linkClass="page-link"
                        prevPageText="Previous"
                        nextPageText="Next"
                      />
                    </Flex>
                  </TableContainer>
                </div>
              </TabPanel>
              <TabPanel className="customer_transaction_panel">
                <OtherChannelsTab
                  channels={channels}
                  channelOptions={channelOptions}
                  currencyList={currencyList}
                  
                  onSave={async (updatedChannels) => {
                    // Your save logic here
                    const url = `${process.env.REACT_APP_API_URL}/sale_channel/update`;
                    const updatedData = {
                      id: +id,
                      other_channel_sale: JSON.stringify(updatedChannels)
                    };
                    await fetchWrapper.post(url, updatedData);
                    await OtherChannelsList(); // Refresh
                    toast.success("Updated successfully");
                  }}
                />
                
              </TabPanel>
              <TabPanel className="customer_transaction_panel">
                {/* Table and filters for SMS Cost */}
                <HStack justifyContent="space-between" mb="25px">
                  <Box>
                    <Text fontSize="32px" fontWeight="300" color="#000000">
                      MAU (Monthly Active Users)
                    </Text>
                  </Box>

                </HStack>

                <MAUForm data={Moudata} />
              </TabPanel>

              <TabPanel className="customer_transaction_panel">
                <BillingCharges />
              </TabPanel>
            </TabPanels>
          </Tabs>
          <Modal isOpen={isModalOpen} size='xl' onClose={onModalClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                {modalType === 'channels' ? 'Select Channels' : 'Set Price'}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                {modalType === 'price' ? (
                  <div className="grid gap-4 py-4">
                    <div className="flex items-center gap-4">
                      <label htmlFor="price" className="text-right">
                        Price: (OTP and Transaction)
                      </label>
                      <Input
                        id="price"
                        type="number"
                        step="0.0001"
                        value={newPrice}
                        onChange={(e) => setNewPrice(e.target.value)}
                        className="w-full"
                        placeholder="Enter price"
                      />

                      <label htmlFor="price" className="text-right">
                        Price: (Marketing and Information)
                      </label>
                      <Input
                        id="price_marketing"
                        type="number"
                        step="0.0001"
                        value={newPriceMarketing}
                        onChange={(e) => setNewPriceMarketing(e.target.value)}
                        className="w-full"
                        placeholder="Enter marketing price"
                      />

                      <label htmlFor="price" className="text-right">
                        Currency
                      </label>
                      <Select
                        placeholder="Select currency"
                        value={selectedCurrencyId}
                        onChange={(e) => setSelectedCurrencyId(e.target.value)}
                      >
                        {currencyList?.map((currency) => (
                          <option key={currency.id} value={currency.id}>
                            {currency.name}
                          </option>
                        ))}
                      </Select>

                    </div>
                  </div>
                ) : (
                  <>
                    <b>OTP and transaction</b>
                    <div className="grid gap-4 py-4">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {channelOptions.map((channel) => (
                          <Checkbox
                            key={channel.id}
                            isChecked={selectedChannel.includes(channel?.id)}
                            onChange={() => handleCheckboxChange(channel?.id)}
                          >
                            {channel.label}
                          </Checkbox>
                        ))}
                      </div>
                    </div>
                    <br />
                    <b>Marketing</b>
                    <div className="grid gap-4 py-4">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {channelOptions.map((channel) => (
                          <Checkbox
                            key={channel.id}
                            isChecked={selectedChannelMarketing.includes(channel?.id)}
                            onChange={() => handleCheckboxChangeMarketing(channel?.id)}
                          >
                            {channel.label}
                          </Checkbox>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </ModalBody>

              <ModalFooter>
                <Button variant="outline" mr={3} onClick={() => setIsModalOpen(false)}>
                  Cancel
                </Button>
                <Button colorScheme="blue" onClick={handleSavePrice}>
                  {modalType === 'channels' ? 'Update Channels' : 'Save Price'}
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
      </BoxWrapper>

      <Modal isOpen={isFixChargesModalOpen} size='lg' onClose={() => setIsFixChargesModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Contract Configuration</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={4}>
              <Text fontSize="sm" color="gray.600">
                Modify the currency and fix charges settings for this sales contract.
              </Text>

              <FormControl>
                <FormLabel>Currency</FormLabel>
                <Select
                  placeholder="Select currency"
                  value={fixChargesConfig.currency_id}
                  onChange={(e) => setFixChargesConfig({
                    ...fixChargesConfig,
                    currency_id: e.target.value
                  })}
                >
                  {currencyList?.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.code} - {currency.name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* <FormControl display="flex" alignItems="center">
                  <Icon as={LuSettings} color="blue.500" mr={2} />
                  <FormLabel htmlFor="fix-charges-switch" mb="0" mr={3}>
                    Fix Charges Configuration
                  </FormLabel>
                  <Switch
                    id="fix-charges-switch"
                    isChecked={fixChargesConfig.enabled}
                    onChange={(e) => setFixChargesConfig({
                      ...fixChargesConfig,
                      enabled: e.target.checked
                    })}
                    colorScheme="blue"
                  />
                </FormControl> */}

              {/* <Text fontSize="sm" color="gray.600">
                  Configure fixed billing charges for this contract
                </Text> */}

              <>
                <FormControl>
                  <FormLabel>Fix Charges Amount ($)</FormLabel>
                  <Input
                    type="number"
                    step="0.01"
                    value={fixChargesConfig.amount}
                    onChange={(e) => setFixChargesConfig({
                      ...fixChargesConfig,
                      amount: parseFloat(e.target.value) || 0
                    })}
                    placeholder="Enter amount"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Charging Method</FormLabel>
                  <RadioGroup
                    value={fixChargesConfig.charging_method}
                    onChange={(value) =>
                      setFixChargesConfig({
                        ...fixChargesConfig,
                        charging_method: value,
                      })
                    }
                  >
                    <Stack spacing={3}>
                      {/* Fixed Monthly Fee */}
                      <Box
                        borderWidth="1px"
                        borderRadius="lg"
                        p={4}
                        cursor="pointer"
                        _hover={{ borderColor: "blue.400" }}
                        borderColor={
                          fixChargesConfig.charging_method === "fixed_monthly"
                            ? "blue.500"
                            : "gray.200"
                        }
                      >
                        <Radio value="fixed_monthly" colorScheme="blue">
                          <Box ml={2}>
                            <Text fontWeight="medium">Fixed Monthly Fee</Text>
                            <Text fontSize="sm" color="gray.600">
                              Charge this amount every month regardless of usage
                            </Text>
                          </Box>
                        </Radio>
                      </Box>

                      {/* Minimum Billing Threshold */}
                      <Box
                        borderWidth="1px"
                        borderRadius="lg"
                        p={4}
                        cursor="pointer"
                        _hover={{ borderColor: "blue.400" }}
                        borderColor={
                          fixChargesConfig.charging_method === "minimum_billing"
                            ? "blue.500"
                            : "gray.200"
                        }
                      >
                        <Radio value="minimum_billing" colorScheme="blue">
                          <Box ml={2}>
                            <Text fontWeight="medium">Minimum Billing Threshold</Text>
                            <Text fontSize="sm" color="gray.600">
                              Only charge if total usage billing is below this amount
                            </Text>
                          </Box>
                        </Radio>
                      </Box>
                    </Stack>
                  </RadioGroup>
                </FormControl>

              </>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button variant="outline" mr={3} onClick={() => setIsFixChargesModalOpen(false)}>
              Cancel
            </Button>
            <Button colorScheme="blue" onClick={handleSaveFixCharges}>
              Save Changes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default SaleList;
